<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="160px" style="width: 600px">
            <el-form-item label="语言" prop="languageId">
                <Language v-model="form.languageId"></Language>
            </el-form-item>
            <el-form-item label="设备默认名称" prop="defaultName">
                <el-input v-model="form.defaultName" placeholder="请输入设备默认名称"></el-input>
            </el-form-item>
            <el-form-item label="设备公共名称" prop="publicName">
                <el-input v-model="form.publicName" placeholder="请输入设备公共名称"></el-input>
            </el-form-item>
            <el-form-item label="设备图标">
                <el-row>
                    <el-col :span="12">
                        <Uploader v-model="form.staticImage" tip="静态图标，支持jpg、png格式"></Uploader>
                    </el-col>
                    <el-col :span="12">
                        <Uploader v-model="form.dynamicImage" tip="动态图标，支持jpg、png、gif格式"></Uploader>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="充电类型" prop="chargingType">
                <el-radio-group v-model="form.chargingType">
                    <el-radio :label="0">连续供电</el-radio>
                    <el-radio :label="1">充电</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="设备标签" prop="tagList">
                <DynamicTag v-model="form.tagList"></DynamicTag>
            </el-form-item>
            <template v-if="form.chargingType == 1">
                <el-form-item label="设备容量 (Wh)" v-num prop="deviceCapacity">
                    <el-input v-model="form.deviceCapacity" placeholder="请输入设备容量"></el-input>
                </el-form-item>
                <el-form-item label="设备充电次数" v-num prop="deviceChargeCount">
                    <el-input v-model="form.deviceChargeCount" placeholder="请输入设备充电次数"></el-input>
                </el-form-item>
                <el-form-item label="总容量 (Wh)" v-num prop="totalCapacity">
                    <el-input disabled v-model="form.totalCapacity"></el-input>
                </el-form-item>
            </template>
            <template v-else>
                <el-form-item label="设备持续功率 (W)" prop="continuousPower">
                    <el-input v-model="form.continuousPower" v-num placeholder="请输入设备持续功率"></el-input>
                </el-form-item>
                <el-form-item label="设备浪涌功率 (W)" prop="surgePower">
                    <el-input v-model="form.surgePower" v-num placeholder="请输入设备浪涌功率"></el-input>
                </el-form-item>
                <el-form-item label="设备运行时间 (min)" prop="operationTime">
                    <el-row type="flex">
                        <el-input :disabled="form.ever" v-model="form.operationTime" v-num
                            placeholder="请输入设备运行时间"></el-input>
                        <el-checkbox v-model="form.ever" style="margin-left: 10px;">持续用电</el-checkbox>
                    </el-row>
                </el-form-item>
            </template>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/device";
import Language from "@/components/Language";
import Uploader from "@/components/Uploader";
import DynamicTag from "@/components/DynamicTag";
export default {
    components: { Language, Uploader, DynamicTag },
    data() {
        return {
            id: null,
            form: {
                languageId: "",
                defaultName: "",
                publicName: "",
                staticImage: "",
                dynamicImage: "",
                chargingType: 0,
                tagList: [],
                deviceCapacity: "",
                deviceChargeCount: "",
                totalCapacity: "",
                continuousPower: "",
                surgePower: "",
                operationTime: "",
                ever: false,
            },
            rules: {
                languageId: [{ required: true, message: "请选择语言", trigger: "change" }],
                defaultName: [{ required: true, message: "请输入设备默认名称", trigger: "blur" }],
                publicName: [{ required: true, message: "请输入设备公共名称", trigger: "blur" }],
                chargingType: [{ required: true, message: "请选择充电类型", trigger: "change" }],
                tagList: [{ required: true, message: "请选择设备标签", trigger: "change" }],
            },
        }
    },
    computed: {
        calc() {
            if (!this.form.deviceCapacity || !this.form.deviceChargeCount) return "";
            return (this.form.deviceCapacity * this.form.deviceChargeCount).toFixed(2);
        }
    },
    watch: {
        calc(val) {
            this.form.totalCapacity = val;
        },
        ['form.ever'](val) {
            if (val) {
                this.form.operationTime = "";
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
    },
    methods: {
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {
                        languageId: +data.languageId,
                        defaultName: data.defaultName,
                        publicName: data.publicName,
                        staticImage: data.staticImage,
                        dynamicImage: data.dynamicImage,
                        chargingType: data.chargingType,
                        tagList: data.tagList,
                        deviceCapacity: data.deviceCapacity,
                        deviceChargeCount: data.deviceChargeCount,
                        totalCapacity: data.totalCapacity,
                        continuousPower: data.continuousPower,
                        surgePower: data.surgePower,
                        operationTime: data.operationTime,
                        ever: data.ever == 1 ? true : false,
                    };
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    ever: this.form.ever ? 1 : 0
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>